export interface NavigationItemContent {
  label: string;
  href?: string;
}

interface NavigationCategoryContent extends NavigationItemContent {
  items: Array<NavigationItemContent>;
}

export function isNavigationCategoryItem(target: NavigationItemContent): target is NavigationCategoryContent {
  return Object.prototype.hasOwnProperty.call(target, "items");
}

export interface NavigationContent {
  items: Array<NavigationCategoryContent | NavigationItemContent>;
}

export interface DRXNavigationContent {
  primaryExpandedContent: NavigationContent;
  secondaryNavigationLinks?: Array<NavigationItemContent>;
  callLinkContent: {
    label: string;
    number: string;
    href: string;
  };
}
